export const API_AGENCIES = 'core/agencies';
export const API_ADMIN_PANEL_AGENCIES = 'core/admin-panel/agencies';
